import { rowColumn } from "../../../components/table/Table";
export const providerListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "KIS Provider",
    column: "providerName",
    type: "string",
    allowSort: true,
    sortOn: "ProviderName",
  },
  {
    label: "Region",
    column: "region",
    type: "string",
    allowSort: true,
    sortOn: "Region",
  },
  {
    label: "Area",
    column: "area",
    type: "string",
    allowSort: true,
    sortOn: "Area",
  },
  {
    label: "KIS Provider email 1",
    column: "providerEmail1",
    type: "string",
    allowSort: true,
    sortOn: "ProviderEmail1",
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.id}`}>View Details</a>,
  },
];
